import '.u{width:100%;}.ssr-plugin'
import '.fz{background-color:lightgray;}.ssr-plugin'
import '.g0{background-size:100px 100px, auto;}.ssr-plugin'
import '.g1{background-repeat:repeat, no-repeat;}.ssr-plugin'
import '.g2{background-position:0% 0%, 0% 0%;}.ssr-plugin'
import '.g3{background-blend-mode:overlay, normal;}.ssr-plugin'
import '.l{display:grid;}.ssr-plugin'
import '.h{align-items:center;}.ssr-plugin'
import '.a0{gap:1rem;}.ssr-plugin'
import '.c{display:flex;}.ssr-plugin'
import '.g{flex-direction:column;}.ssr-plugin'
import '.af{background-color:var(--palette-white);}.ssr-plugin'
import '.g4{border-radius:var(--border-radius-image);}.ssr-plugin'
import '.g5{padding:3.5rem 2rem;}.ssr-plugin'
import '.j{text-align:center;}.ssr-plugin'
import '.b9{height:100%;}.ssr-plugin'
import '.g6{width:12.5rem;}.ssr-plugin'
import '.g7{grid-template-rows:auto 1fr auto;}.ssr-plugin'
import '.bb{flex:1;}.ssr-plugin'
import '.d{justify-content:center;}.ssr-plugin'
import '.g8{padding:0.75rem 0;}.ssr-plugin'
import FreddieImage from '@app/assets/images/about-us/team/Freddie.jpg'
import SaschaImage from '@app/assets/images/about-us/team/Sascha-two.jpg'
import { Button } from '@app/components/core/button/Button'
import { Image } from '@app/components/core/image/Image'
import { Paragraph } from '@app/components/core/typography/Paragraph'
import { Title } from '@app/components/core/typography/Title'
import useMediaQuery from '@app/util/useMediaQuery'
import contactCardTexture from '@app/assets/images/background-contact-card.png'
import { type Style, styled } from 'inlines'
import { useTranslations } from '@i18n/useLanguage'

type ContactPerson = {
  imageSrc: string
  imageAlt: string
  name: string
  role: string
  link: string
}

export type ContactCardProps = {
  style?: Style
}

export const ContactCard = ({ style }: ContactCardProps) => {
  const isMobile = useMediaQuery()
  const t = useTranslations()

  const CONTACT_PEOPLE: ContactPerson[] = [
    {
      imageSrc: SaschaImage,
      imageAlt: 'Portrait of Sascha Glasl',
      name: 'Sascha \nGlasl',
      role: t.app.forMunicipalities.contact.people.sascha.role,
      link: 'https://meetings-eu1.hubspot.com/sascha-glasl',
    },
    {
      imageSrc: FreddieImage,
      imageAlt: 'Portrait of Freddie Aldershoff',
      name: 'Freddie Aldershoff',
      role: t.app.forMunicipalities.contact.people.freddie.role,
      link: 'https://meetings-eu1.hubspot.com/freddie-aldershoff/freddie-demo',
    },
  ]

  return (
    <styled.div className="u fz g0 g1 g2 g3"
      style={{
        backgroundImage: `url(${contactCardTexture}), linear-gradient(177deg, #FFF 13.41%, #FBEBD1 66.89%, #FFCB93 93.89%, #F1A782 115.68%)`,
        borderRadius: isMobile ? '0.5rem' : '3rem',
        padding: isMobile ? '0.5rem' : '4.5rem',
        ...style,
      }}
    >
      <div className="l h"
        style={{
          gridTemplateColumns: isMobile ? '1fr' : 'minmax(0, 1fr) auto',
          gap: isMobile ? '2rem' : '9rem',}}
      >
        <styled.div>
          <Title.H2>{t.app.forMunicipalities.contact.title}</Title.H2>
          <Paragraph.Medium>
            {t.app.forMunicipalities.contact.description}
          </Paragraph.Medium>
        </styled.div>

        <div className="u l a0"
          style={{
            gridTemplateColumns: isMobile
              ? '1fr'
              : 'repeat(2, minmax(13rem, 1fr))',}}
        >
          {CONTACT_PEOPLE.map((person) => (
            <div className="c g af g4 g5 h j b9"
              key={person.name}
            >
              <Image
                src={person.imageSrc}
                alt={person.imageAlt}
                resizeWidth={144}
                style={{
                  width: '9rem',
                  height: '9rem',
                  borderRadius: '50%',
                  objectFit: 'cover',
                  objectPosition: 'center top',
                  marginBottom: '0.75rem',
                }}
              />
              <div className="g6 l g7 b9 bb"
              >
                <Title.H4
                  style={{
                    whiteSpace: 'pre-line',
                    marginBottom: 0,
                  }}
                >
                  {person.name}
                </Title.H4>
                <div className="c h d j g8"
                >
                  <Paragraph.Medium
                    style={{
                      marginBottom: 0,
                    }}
                  >
                    {person.role}
                  </Paragraph.Medium>
                </div>
                <Button
                  size="medium"
                  variant="primary"
                  label={t.app.forMunicipalities.contact.buttonLabel}
                  to={person.link}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </styled.div>
  )
}
